<template>
  <md-card>
    <md-card-header class="md-card-header-icon md-card-header-blue">
      <div class="card-icon">
        <md-icon v-if="tour.type.value == 'tour'">public</md-icon>
        <md-icon v-else>event</md-icon>
      </div>
      <h4 class="title">
        {{ tour.title }}
        <md-button
          v-if="canEdit"
          class="md-icon-button md-dense md-success md-simple"
          @click="editTourTitle"
        >
          <md-icon>edit</md-icon>
        </md-button>
      </h4>
    </md-card-header>
    <md-card-content>
      <div class="md-layout">
        <div class="md-layout-item md-size-100">
          <p class="md-caption text-warning">
            This is {{ tour.type.value == "tour" ? "a Tour" : "an Event" }}
          </p>
        </div>
        <div class="md-layout-item md-size-100">
          <text-editor v-if="canEdit" v-model="tour.description" />
          <div v-else class="desc_wrapper" v-html="tour.description"></div>
        </div>

        <template v-if="canEdit">
          <div class="md-layout-item md-size-90 mt-4">
            <md-field class="">
              <label>Partner</label>
              <md-select v-model="tour.supplier.id">
                <md-option
                  v-for="item in suppliers"
                  :value="item.id"
                  :key="item.id"
                >
                  {{ item.company }}
                </md-option>
              </md-select>
            </md-field>
          </div>
          <div class="md-layout-item md-size-10 text-right button-holder">
            <md-button
              class="md-icon-button md-dense md-danger md-simple"
              @click="clearSupplier"
            >
              <md-icon>clear</md-icon>
              <md-tooltip md-direction="top">Clear the Partner</md-tooltip>
            </md-button>
          </div>
        </template>
        <div v-else class="md-layout-item md-size-100 mt-4">
          <p><strong>Partner: </strong>{{ tour.supplier.company }}</p>
        </div>

        <h6 class="md-layout-item md-size-100">Default Departure Group Size</h6>
        <div class="md-layout-item md-size-50">
          <md-field>
            <md-icon
              ><i class="fas fa-user-minus text-primary hi-price-icon"></i
            ></md-icon>
            <label>Min Group Size</label>
            <md-input
              :readonly="!canEdit"
              type="number"
              v-model="tour.min_group_size"
              min="1"
            ></md-input>
          </md-field>
        </div>
        <div class="md-layout-item md-size-50">
          <md-field>
            <md-icon
              ><i class="fas fa-user-plus text-primary hi-price-icon"></i
            ></md-icon>
            <label>Max Group Size</label>
            <md-input
              :readonly="!canEdit"
              type="number"
              v-model="tour.max_group_size"
              min="1"
            ></md-input>
          </md-field>
        </div>

        <div class="md-layout-item md-size-50">
          <md-switch v-model="tour.public" :disabled="!canEdit"
            >Public</md-switch
          >
        </div>
        <div class="md-layout-item md-size-50">
          <md-switch v-model="tour.archived" :disabled="!canEdit"
            ><span :class="{ 'text-danger': tour.archived }"
              >Archived</span
            ></md-switch
          >
        </div>

        <div class="md-layout-item md-size-100">
          <div class="md-caption">Created On</div>
          <div class="">{{ tour.created_at | formatDate }}</div>
        </div>

        <div v-if="canEdit" class="md-layout-item md-size-100">
          <md-button
            class="md-raised md-dense md-success mt-4"
            @click.prevent="updateTour"
            >Update</md-button
          >
        </div>
      </div>

      <md-dialog :md-active.sync="showDialog">
        <md-dialog-title>Adventure Title</md-dialog-title>
        <ValidationObserver v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(updateTourTitle)" class="mt-4">
            <div class="md-layout">
              <div class="md-layout-item md-size-100">
                <ValidationProvider
                  name="Tour Title"
                  rules="required"
                  v-slot="{ passed, failed }"
                >
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>Adventure Title</label>
                    <md-input v-model="newTourTitle" type="text"></md-input>
                    <slide-y-down-transition>
                      <md-icon class="error" v-show="failed">close</md-icon>
                    </slide-y-down-transition>
                    <slide-y-down-transition>
                      <md-icon class="success" v-show="passed">done</md-icon>
                    </slide-y-down-transition>
                  </md-field>
                </ValidationProvider>
              </div>
            </div>
            <md-dialog-actions>
              <md-button class="md-primary md-dense" @click="hideDialog"
                >Cancel</md-button
              >
              <md-button type="submit" class="md-primary md-dense"
                >Save</md-button
              >
            </md-dialog-actions>
          </form>
        </ValidationObserver>
      </md-dialog>
    </md-card-content>
  </md-card>
</template>

<script>
import tourApi from "@/services/api/tour";
import supplierApi from "@/services/api/supplier";

export default {
  props: {
    tour: {
      type: Object,
      supplier: {
        id: null
      }
    }
  },

  data() {
    return {
      suppliers: [],
      newTourTitle: "",
      showDialog: false
    };
  },

  computed: {
    canEdit() {
      return (
        this.$allowed(["tour.manage", "tour.update"]) ||
        (this.isSupplier && this.$allowed(["tour.update.own"]))
      );
    },
    isSupplier() {
      return this.tour.supplier.id == this.$store.state.auth.user.supplier.id;
    }
  },

  methods: {
    updateTour() {
      tourApi.updateTour(this.tour).then(response => {
        this.$notify({
          timeout: 2500,
          message: "The Tour has been updated.",
          icon: "thumb_up",
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "success"
        });
      });
    },

    editTourTitle() {
      this.newTourTitle = this.tour.title;
      this.showDialog = true;
    },

    updateTourTitle() {
      this.tour.title = this.newTourTitle;
      this.hideDialog();
      this.updateTour();
    },

    hideDialog() {
      this.showDialog = false;
      this.newTourTitle = "";
    },

    getSuppliers() {
      supplierApi.getAll().then(response => {
        this.suppliers = response.data;
      });
    },

    clearSupplier() {
      this.tour.supplier.id = null;
    }
  },

  created() {
    this.getSuppliers();
  }
};
</script>
<style lang="scss" scoped>
.desc_wrapper {
  border: 1px solid #00bcd4;
  border-radius: 5px;
  padding: 5px 10px;
}
.button-holder {
  align-items: end;
}
h4 {
  &.title {
    button {
      height: 24px !important;
    }
  }
}
</style>
